// Vessel silhouettes for the Ship Happens fleet.
//
// Single-weight line drawings, one per ship, in currentColor so the card
// decides whether they read white-on-ink or ink-on-paper. Deliberately graphic
// rather than illustrative: the cover carries all the photographic weight on
// that page, and a second visual register beside it would compete with it.
//
// Every path shares one viewBox and stroke so the set reads as a set.
const SW = 1.6;

const ICONS = {
  "relation-ship": (
    // The submarine — the only hull drawn below the line.
    <>
      <path d="M4 30 Q8 24 24 24 T44 30 Q40 36 24 36 T4 30 Z" />
      <path d="M20 24v-5h8v5" />
      <path d="M26 19v-6h3" />
      <path d="M8 16q3-2 6 0t6 0" />
    </>
  ),
  "friend-ship": (
    // The sailboat — moved by wind it cannot control.
    <>
      <path d="M8 34h32l-4 6H12z" />
      <path d="M24 8v26" />
      <path d="M24 10 38 32H24z" />
      <path d="M24 14 12 32h12z" />
    </>
  ),
  "fellow-ship": (
    // The ferry — everybody on the same deck.
    <>
      <path d="M6 30h36l-4 8H10z" />
      <path d="M12 30v-8h24v8" />
      <path d="M16 26h2M22 26h2M28 26h2M34 26h-2" />
      <path d="M30 22v-5h4v5" />
    </>
  ),
  "mentor-ship": (
    // The lighthouse — fixed position, at a distance.
    <>
      <path d="M19 40l2-24h6l2 24z" />
      <path d="M17 40h14" />
      <path d="M20 16h8v-5h-8z" />
      <path d="M8 40q8-4 16 0t16 0" />
      <path d="M32 11l6-3M32 14h7M32 8l4-5" />
    </>
  ),
  "apprentice-ship": (
    // The fishing boat — nets in your hands.
    <>
      <path d="M8 32h32l-5 7H13z" />
      <path d="M14 32v-7h10v7" />
      <path d="M30 32V12" />
      <path d="M30 14l10 10" />
      <path d="M34 24q3 3 6 0M36 27q2 2 4 0" />
    </>
  ),
  "disciple-ship": (
    // The vessel you're taken aboard — a gangway up, not a view from shore.
    <>
      <path d="M12 30h30l-4 8H16z" />
      <path d="M18 30v-9h16v9" />
      <path d="M26 21v-6h5" />
      <path d="M4 40l12-12" />
      <path d="M7 37l2 2M10 34l2 2M13 31l2 2" />
    </>
  ),
  "steward-ship": (
    // The cargo ship — carrying what was entrusted, intact.
    <>
      <path d="M4 32h40l-5 7H9z" />
      <path d="M8 32v-6h8v6M16 32v-6h8v6M24 32v-6h8v6" />
      <path d="M12 26v-5h8v5M20 26v-5h8v5" />
      <path d="M34 32V20h6v12" />
    </>
  ),
  "hard-ship": (
    // The icebreaker — built for what stops other vessels.
    <>
      <path d="M10 32l4-8h26l4 8-4 6H14z" />
      <path d="M20 24v-6h10v6" />
      <path d="M24 18v-4" />
      <path d="M3 30l3-4 2 4M4 37l3-4 3 4" />
      <path d="M10 32h34" />
    </>
  ),
  "owner-ship": (
    // The tugboat — small, precise strength.
    <>
      <path d="M8 32h30l-4 7H12z" />
      <path d="M14 32V22h12v10" />
      <path d="M18 22v-6h6v6" />
      <circle cx="10" cy="34" r="1.3" />
      <circle cx="16" cy="36" r="1.3" />
      <path d="M38 32q4-4 6-2" />
    </>
  ),
  "worship-ship": (
    // The aircraft carrier — the platform everything launches from.
    <>
      <path d="M4 28h40l-3 6H9z" />
      <path d="M30 28v-8h8v8" />
      <path d="M34 20v-4" />
      <path d="M12 26l6-4 2 2-6 4z" />
      <path d="M8 34h32" />
    </>
  ),
};

export default function ShipIcon({ id, size = 40, className = "" }) {
  const paths = ICONS[id];
  if (!paths) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth={SW}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths}
    </svg>
  );
}
